const Experience = () => {
    return (
        <div className="experience">
            <h2>Education</h2>

            <ul>
                <li>
                    <i>International Institute of Information Technology Naya Raipur</i>, 2019-2023
                    <ul>
                        <li>CGPA 8.17 </li>
                    </ul>
                </li>
            </ul>
        </div>

        
    );
}

export default Experience;